
/* footer menu */
$(function () {
    var toggle = $('.footermenuToggle');
    var footer_break_point = 768;
    var browser_width = window.innerWidth;

    toggle.click(function () {
        event.preventDefault();
        $(this)
            .parent()
            .toggleClass('__active');
        $(this)
            .siblings()
            .slideToggle();
    });

    function initFooterToggle() {
        if (browser_width >= footer_break_point) {
            toggle.attr('tabindex', '-1');
        }

        else {
            toggle.attr('tabindex', '0');
        }
    };

    initFooterToggle();

    $(window).resize(function () {
        initFooterToggle();
    });
});